import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import {
  getBOPartReport,
  getBODivisionValue,
  getBOGraphValue,
  getBORange,
  getBOTableData,
  getCardValue,
  getBOLocationReport,
} from "../api/boPart";

export const fetchBoRange = createAsyncThunk(
  "boParts/fetchBoRange",
  async (params) =>
    getBORange(
      params?.location,
      params?.division,
      params?.department,
      params?.vendor,
      params?.timeline
    ).then((res) => res)
);

export const fetchCardValue = createAsyncThunk(
  "boParts/fetchCardValue",
  async (params) =>
    getCardValue(
      params?.location,
      params?.division,
      params?.department,
      params?.vendor,
      params?.timeline,
      params?.days,
      params?.rangeValue
    ).then((res) => res)
);

export const fetchBODivisionValue = createAsyncThunk(
  "boParts/fetchBODivisionValue",
  async (params) =>
    getBODivisionValue(
      params?.location,
      params?.division,
      params?.department,
      params?.vendor,
      params?.timeline,
      params?.days,
      params?.rangeValue
    ).then((res) => res)
);

export const fetchBoGraphValue = createAsyncThunk(
  "boParts/fetchBoGraphValue",
  async (params) =>
    getBOGraphValue(
      params?.aggr,
      params?.location,
      params?.division,
      params?.department,
      params?.vendor,
      params?.timeline,
      params?.days,
      params?.rangeValue,
      params?.page,
      params?.limit,
      params?.sort
    ).then((res) => res)
);

export const fetchBoTableData = createAsyncThunk(
  "boParts/fetchBoTableData",
  async (params) =>
    getBOTableData(
      params?.location,
      params?.division,
      params?.department,
      params?.vendor,
      params?.timeline,
      params?.days,
      params?.rangeValue,
      params?.page,
      params?.limit,
      params?.sort,
      params?.sort_by
    ).then((res) => res)
);

export const fetchBOPartReport = createAsyncThunk(
  "boParts/fetchBOPartReport",
  async (params) =>
    getBOPartReport(
      params?.location,
      params?.division,
      params?.department,
      params?.vendor,
      params?.timeline,
      params?.days,
      params?.rangeValue
    ).then((res) => res)
);

export const fetchBOLocationReport = createAsyncThunk(
  "boParts/fetchBOLocationReport",
  async (params) => getBOLocationReport(params?.location).then((res) => res)
);

export const boPartsSlice = createSlice({
  name: "boParts",
  initialState: {
    rangeDetails: null,
    cardValueDetails: null,
    boDivisionValueDetails: null,
    boGraphValueDetails: null,
    boTableValueDetails: null,
    loading: false,
    tableLoading: false,
    boPartReport: null,
    boLocationReport: null
  },
  extraReducers: {
    [fetchBoRange.pending]: (state, { payload }) => {
      state.loading = true;
    },
    [fetchBoRange.fulfilled]: (state, { payload }) => {
      state.rangeDetails = payload;
      state.loading = false;
    },
    [fetchBoRange.rejected]: (state, { payload }) => {
      state.loading = false;
    },
    [fetchCardValue.fulfilled]: (state, { payload }) => {
      state.cardValueDetails = payload;
    },
    [fetchBODivisionValue.pending]: (state, { payload }) => {
      state.loading = true;
    },
    [fetchBODivisionValue.fulfilled]: (state, { payload }) => {
      state.boDivisionValueDetails = payload;
      state.loading = false;
    },
    [fetchBODivisionValue.rejected]: (state, { payload }) => {
      state.loading = false;
    },
    [fetchBoGraphValue.fulfilled]: (state, { payload }) => {
      state.boGraphValueDetails = payload;
    },
    [fetchBoTableData.pending]: (state, { payload }) => {
      state.tableLoading = true;
    },
    [fetchBoTableData.fulfilled]: (state, { payload }) => {
      state.boTableValueDetails = payload;
      state.tableLoading = false;
    },
    [fetchBoTableData.rejected]: (state, { payload }) => {
      state.boTableValueDetails = payload;
      state.tableLoading = false;
    },
    [fetchBOPartReport.pending]: (state, { payload }) => {
      state.loading = true;
    },
    [fetchBOPartReport.fulfilled]: (state, { payload }) => {
      state.boPartReport = payload;
      state.loading = false;
    },
    [fetchBOPartReport.rejected]: (state, { payload }) => {
      state.loading = false;
    },
    [fetchBOLocationReport.pending]: (state, { payload }) => {
      state.loading = true;
    },
    [fetchBOLocationReport.fulfilled]: (state, { payload }) => {
      state.boLocationReport = payload;
      state.loading = false;
    },
    [fetchBOLocationReport.rejected]: (state, { payload }) => {
      state.loading = false;
    },
  },
});

export default boPartsSlice.reducer;
